import type { B2bcsSubmitLeadFormInput } from './types/generated';

export const MIN_CONSUMPTION = 1;
export const MAX_CONSUMPTION = 2_000_000_000;
export const MIN_METERS = 1;
export const MIN_PEAK_OUTPUT = 1;
export const MAX_PEAK_OUTPUT = 10_000;
export const MIN_INSTALLATION_YEAR = 1900;
export const MAX_INSTALLATION_YEAR = new Date().getFullYear();

export const LEAD_DATA_MAX_LENGTHS: Record<keyof Omit<B2bcsSubmitLeadFormInput, 'consents'>, number> = {
  channelDetail: 100,
  city: 80,
  companyName: 100,
  duns: 10,
  emailAddress: 100,
  firstname: 50,
  houseNumber: 100,
  interest: 2000,
  lastname: 50,
  postalCode: 20,
  street: 100,
  telephoneNumber: 50,
  webCampaignId: 200,
};
